import Swiper from 'swiper';
import {
    Navigation,
    Pagination,
    Keyboard,
    Autoplay,
    EffectFade,
} from 'swiper/modules';

import AOS from 'aos';
  
Swiper.use([Navigation, Pagination, Keyboard, Autoplay, EffectFade]);

const navigation = (target) => {
    return {
        nextEl: `.${target}-swiper-button--next`,
        prevEl: `.${target}-swiper-button--prev`,
    };
};
  
$(window).on('load', function () {
    swipers();
});
  
const swipers = () => {
    sliderImages();
    membersSwiper();
    logosSwiper();
};

const logosSwiper = () => {
    return new Swiper('.module--logos__items', {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        autoplay: {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
    });
};

const membersSwiper = () => {
    return new Swiper('.module--members__items', {
        loop: false,
        spaceBetween: 30,
        slidesPerView: 1.1,
        navigation: navigation('module--members__items__nav'),
        breakpoints: {
            768: {
                slidesPerView: 3.1,
            },
        },
    });
};

const sliderImages = () => {
    return new Swiper('.module--slider__images', {
        loop: false,
        spaceBetween: 24,
        slidesPerView: 1.3,
        navigation: navigation('module--slider__images__nav'),
    });
};

$(window).on('resize', function () {
    AOS.refresh();
});
